module.exports = __webpack_public_path__ + "img/style-tile-desktop.b5722ec3.png";